import React from 'react'

import isNil from 'lodash/isNil'
import noop from 'lodash/noop'

import useUniqueId from '../../hooks/use-unique-id'
import cn from '../../libs/class-names'

export interface Props {
  classNames?: string[]
  label: React.ReactNode
  aside?: React.ReactNode
  name?: string
  checked?: boolean
  value?: string
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  id?: string
}

const RadioPillItem = ({
  classNames,
  id,
  name,
  label,
  aside,
  checked = false,
  onChange = noop,
  value = '',
}: Props) => {
  const actualId = useUniqueId(id)

  return (
    <label
      htmlFor={actualId}
      className={cn('RadioPillItem', {checked}, classNames)}
      aria-checked={checked}
    >
      <input
        id={actualId}
        className="RadioPillItem__input"
        type="radio"
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
      />
      <div className="RadioPillItem__label">{label}</div>
      {!isNil(aside) && <div className="RadioPillItem__aside">({aside})</div>}
    </label>
  )
}

export default RadioPillItem
